import React from 'react';
import {
  IconButton,
  makeStyles,
  colors,
  CircularProgress,
} from '@material-ui/core';
import { Bookmark, BookmarkBorder } from '@material-ui/icons';

import useBookmarkRecipe from 'domain/recipe/useBookmarkRecipe';

const useStyles = makeStyles({
  notBookmarked: {
    color: colors.grey[400],
    '&:hover': {
      backgroundColor: colors.red[100],
      color: colors.red[400],
    },
  },
  bookmarked: {
    color: colors.red[400],
    '&:hover': {
      backgroundColor: colors.grey[300],
      color: colors.grey[400],
    },
  },
});

const BookmarkButton = ({ recipeID, bookmarked, onDone }) => {
  const classes = useStyles();
  const { isBookmarking, onBookmarked } = useBookmarkRecipe({
    recipeID,
    bookmarked,
    onDone,
  });

  return isBookmarking ? (
    <CircularProgress
      size={44}
      style={{ color: colors.red[400] }}
    ></CircularProgress>
  ) : (
    <IconButton
      className={bookmarked ? classes.bookmarked : classes.notBookmarked}
      onClick={onBookmarked}
    >
      {bookmarked ? <Bookmark></Bookmark> : <BookmarkBorder></BookmarkBorder>}
    </IconButton>
  );
};

export default BookmarkButton;
